import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

const getByIDRequest = async (id) => {
  return await axios.get(`/api/companies/${id}`);
};

export const useGetCompanyById = (id, config = {}) => {
  return useQuery(['company', id], () => getByIDRequest(id), {
    select: ({ data }) => data,
    ...config,
    enabled: !!id,
  });
};
